import(/* webpackMode: "eager" */ "/app/packages/apps/maui/app/(public)/[...path]/error.tsx");
